import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import app from './modules/app/appStore';
import auth from './modules/auth/authStore';
import theme from './modules/theme/themeStore';
import vehicleApplication from './modules/vehicleApplication/vehicleApplicationStore';
import shortList from './modules/shortList/shortListStore';
import ratebook from './modules/ratebook/ratebookStore';
import vehicleSearchConfig from './modules/vehicleSearchConfig/vehicleSearchConfigStore';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'dragonball-vuex',
  storage: window.localStorage,
  modules: ['auth', 'vehicleApplication']
});

export default new Vuex.Store({
  modules: {
    app,
    auth,
    theme,
    vehicleApplication,
    shortList,
    vehicleSearchConfig,
    ratebook
  },
  plugins: [vuexLocal.plugin]
});
